"use client"; // Ensures the component runs on the client side

import { Link } from 'react-router-dom';
import { useState } from "react";

export default function ServicesOne() {
  // State for dynamic data (e.g., dynamic images, text, links)
  const [servicesContent] = useState({
    sectionTagline: "Why Choose U Brand It",
    sectionTitle: "Your Partner in Promotional Excellence",
    services: [
      {
        id: 1,
        title: "Budget-Friendly Solutions",
        description: "Get the best value without compromising quality. We work with trusted suppliers to offer competitive pricing on thousands of promotional products, with options for every budget.",
        icon: "fas fa-dollar-sign",
        link: "/services",
      },
      {
        id: 2,
        title: "Simple Design Process",
        description: "Our experienced team makes customization easy. From artwork setup to product selection, we guide you through every step to ensure your brand looks its best.",
        icon: "fas fa-pencil-ruler",
        link: "/services",
      },
      {
        id: 3,
        title: "Premium Brand Standards",
        description: "We partner with reputable manufacturers to deliver products that last. Every item is quality-checked to ensure your brand is represented with excellence.",
        icon: "fas fa-award",
        link: "/services",
      },
    ],
  });

  return (
    <>
      {/* Services One Start */}
      <section id="th-service" className="services-one">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">{servicesContent.sectionTagline}</span>
            </div>
            <h2 className="section-title__title">{servicesContent.sectionTitle}</h2>
          </div>
          <div className="row">
            {servicesContent.services.map((service) => (
              <div key={service.id} className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="100ms">
                <div className="services-one__single">
                  <div className="services-one__icon">
                    <i className={service.icon}></i>
                  </div>
                  <h3 className="services-one__title">
                    <Link to={service.link}>{service.title}</Link>
                  </h3>
                  <p className="services-one__text">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Services One End */}
    </>
  );
}
